import { fade, makeStyles } from "@material-ui/core/styles";
import Leaf from "../../images/bgleaf.png";

const styles = makeStyles((theme) => ({
    wrapper: {
		width: "50%",
		position: "relative",
		listStyle: "none",
		float: "left",		
		[theme.breakpoints.down("sm")]: {
			marginBottom: 90
		},
		[theme.breakpoints.down("xs")]: {
			width: "100%"
		},
		"& p": {
			textAlign: "justify"
		},
		"&.contactwrap": {
			"& p": {
				textAlign: "inherit"
			}
		},
		"&:nth-child(even)": {
			marginTop: 200,
			[theme.breakpoints.down("xs")]: {
				marginTop: 0
			}
		},
		"&:nth-child(1)": {
			"& .leftclass": {
				position: "absolute"
			}
		},
		"&:nth-child(2)": {
			"& .leftclass": {
				textAlign: "left"
			}
		},
		"&:nth-child(3)": {
			display: "flex",
			flexDirection: "row-reverse",
			[theme.breakpoints.down("md")]: {
				flexDirection: "row-reverse",
				marginTop: -120,
			},
			[theme.breakpoints.down("lg")]: {
				flexDirection: "row-reverse",
				marginTop: -120,
			},		
			[theme.breakpoints.down("sm")]: {
				flexDirection: "unset"
			},
			[theme.breakpoints.down("xs")]: {
				marginTop: 0,
				flexDirection: "unset"
			},
			"& img": {
				marginRight: -70,
				[theme.breakpoints.down("sm")]: {
					marginRight: 0
				},
				[theme.breakpoints.down("xs")]: {
					marginRight: 0
				}
			},
			"& .leftclass": {
				left: -70,
				[theme.breakpoints.down("md")]: {
					left: 0
				},
				[theme.breakpoints.down("sm")]: {
					left: -70
				},
				[theme.breakpoints.down("xs")]: {
					left: 0
				}
			}
		},
		"&:nth-child(4)": {
			display: "flex",	
			flexDirection: "row-reverse",		
			[theme.breakpoints.down("md")]: {
				flexDirection: "row-reverse",
				marginTop: 70,
			},
			[theme.breakpoints.down("lg")]: {
				flexDirection: "row-reverse",
				marginTop: 70,
			},			
			[theme.breakpoints.down("sm")]: {
				flexDirection: "unset"
			},
			[theme.breakpoints.down("xs")]: {
				flexDirection: "unset"
			},
			"& img": {
				marginRight: -70,
				[theme.breakpoints.down("sm")]: {
					marginRight: 0
				},
				[theme.breakpoints.down("xs")]: {
					marginRight: 0
				}
			},
			"& .leftclass": {
				left: -70,
				textAlign: "left",
				[theme.breakpoints.down("sm")]: {
					left: 0
				}
			}
		}
	},
	left: {
		top: 50,
		width: "40%;",
		zIndex: 1,
		textAlign: "right",
		color: "#fff",
		position: "relative",
		float: "left",
		transition: "all ease .5s",
		"& .h1": {
			fontSize: 45,

			[theme.breakpoints.down("md")]: {
				fontSize: 30
			}
		}
	},
	right: {
		width: "60%",
		float: "right",
		transition: "all ease .5s",
		"& img": {
			maxWidth: "initial",
			maxWidth: 360,
			height: 540,
			width: 360,
			overflow: 'hidden',
			float: "right",
			marginRight: 70,
			transition: "all ease .5s",
			[theme.breakpoints.down("sm")]: {
				marginRight: 0
			},
			[theme.breakpoints.down("lg")]: {
				maxWidth: "100%"
			}
		}
	},
	discover: {
		fontSize: 24,
		"& a": {
			color: "#fff",
			transition: "all ease .5s",
			textDecoration: "underline"
		},
		[theme.breakpoints.down("md")]: {
			fontSize: 20
		}
	},

	content: {
		position: "absolute",
		width: 350,
		transition: "all ease .5s",
		background: "#000000ba",
		padding: "10px 20px",
		color: "#fff",
		paddingBottom: 20,
		"& .newBrave": {
			fontFamily: "BreveSC !important"
		},
		"& p": {
			[theme.breakpoints.down("lg")]: {
				display: "-webkit-box",
				WebkitLineClamp: 10,
				WebkitBoxOrient: "vertical",
				overflow: "hidden"
			},
			[theme.breakpoints.down("md")]: {
				WebkitLineClamp: 7,

				maxHeight: 255
			},
			[theme.breakpoints.down("xs")]: {
				WebkitLineClamp: 5
			}
		},
		[theme.breakpoints.down("md")]: {
			width: 250
		},
		[theme.breakpoints.down("xs")]: {
			width: 250
		}
	},

	bannerwrapper: {
		position: "relative",
		margin: "auto",
		marginTop: 20,
		marginBottom: 50,
		transition: "all ease .5s",
		[theme.breakpoints.down("md")]: {
			marginBottom: 0
		},
		[theme.breakpoints.down("xs")]: {
			marginBottom: 0
		}
	},
	bwrapper: {
		maxWidth: 1700,
		margin: "auto",
		width: "90%",
		transition: "all ease .5s"
	},

	cardsmain: {
		margin: "auto",
		padding: 0,
		maxWidth: 1600,
		transition: "all ease .5s"
	},
	arrows: {
		width: 52,
		position: "relative",
		height: 0,
		margin: "auto",
		top: -70,
		transition: "all ease .5s",
		[theme.breakpoints.down("sm")]: {
			top: -20
		},
		"& span:nth-child(1)": {
			transform: "rotate(180deg)",
			position: "absolute",
			left: 0,
			cursor: "pointer"
		},
		"& span:nth-child(2)": {
			position: "absolute",
			right: 0,
			top: 3,
			cursor: "pointer",
			transition: "all ease .5s"
		}
	},
	rooms: {
		display: "flex",
		margin: "3% 0",
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column"
		},
		"& .left": {
			width: "50%",
			maxWidth: 640,
			position: "relative",
			margin: "auto",
			transition: "0.3s",
			[theme.breakpoints.down("sm")]: {
				width: "100%"
			},
			"& .roomBg": {
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				background: "#fff",
				width: "85%",
				height: 500,
				margin: "auto",
				transition: "0.3s",
				"& .roomOutline": {
					border: "1px solid #000",
					margin: 20,
					height: "calc(100% - 40px)",
					transition: "0.3s",
					"& p": {
						padding: "20px 40px",
						textAlign: "justify",
						maxHeight: 293,
						overflow: "hidden",
						transition: "0.3s",
						[theme.breakpoints.down("md")]: {
							fontSize: 13,
							padding: "0px 20px",
							overflow: "scroll"
						},
						[theme.breakpoints.down("xs")]: {
							maxHeight: 313
						}
					},
					"& .roomHeader": {
						borderBottom: "1px solid #000",
						margin: "0px 50px",
						padding: "10px 0px",
						[theme.breakpoints.down("xs")]: {
							margin: "0px 30px"
						},
						"& span": {
							display: "flex",
							width: "60%",
							margin: "auto",
							fontFamily: "BreveSC",
							fontSize: 36,
							transition: "0.3s",
							[theme.breakpoints.down("md")]: {
								width: "",
								fontSize: 30
							},
							[theme.breakpoints.down("xs")]: {
								width: "100%",
								fontSize: 25
							},
							"&:nth-child(1)": {
								justifyContent: "flex-start"
							},
							"&:nth-child(2)": {
								justifyContent: "flex-end"
							}
						}
					}
				}
			}
		},
		"& .right": {
			width: "50%",
			transition: "0.3s",
			[theme.breakpoints.down("sm")]: {
				width: "100%"
			},
			"& .grid": {
				display: "grid",
				gridTemplateColumns: "repeat(auto-fill, minmax(254px, 1fr))",
				gridGap: "1rem",
				width: 555,
				margin: "80px auto",
				transition: "0.3s",
				[theme.breakpoints.down("md")]: {
					width: "100%",
					gridTemplateColumns: "repeat(auto-fill, minmax(215px, 1fr))"
				},
				[theme.breakpoints.down("sm")]: {
					padding: "0 65px",
					margin: "40px auto"
				},
				[theme.breakpoints.down("xs")]: {
					padding: "0 45px",
					margin: "40px auto"
				},
				"& div": {
					borderRadius: "1rem",
					height: 350,
					overflow: "hidden",
					transition: "0.3s",
					[theme.breakpoints.down("md")]: {
						height: 270
					},
					"& .bg": {
						display: "flex",
						height: "100%",
						background: "#0000007a",
						"& section": {
							margin: "auto",
							color: "#fff",
							fontFamily: "BreveSC",
							fontSize: 36,
							[theme.breakpoints.down("sm")]: {
								fontSize: 30
							}
						}
					}
				}
			}
		}
	},
	activitiesWrapper: {},
	activityItem: {
		minHeight: 400,
		padding: 40,
		color: "#fff",
		paddingRight: "5%",
		transition: "0.3s",
		[theme.breakpoints.down("md")]: {
			paddingRight: "30px 10px"
		},
		"&.color": {},
		"&.image": {
			backgroundAttachment: "fixed",
			backgroundPosition: "center",
			backgroundRepeat: "no-repeat",
			backgroundSize: "cover"
		},
		"&.name": {
			color: "red"
		},
		"& .h1": {
			marginBottom: 30
		},
		"& .h2": {
			marginBottom: 30
		},
		"& .link": {
			fontSize: 20,
			textDecoration: "underline",
			cursor: "pointer",
			margin: "20px 0px"
		}
	},
    leafwrapper: {
		backgroundImage: `url(${Leaf})`,
		width: 250,
		height: 300,
		backgroundSize: "cover",
		display: "block",
		position: "absolute",
		bottom: -150,
		left: -20,
		zIndex: -1,
		[theme.breakpoints.down("sm")]: {
			display: "none"
		}
	},
	root: {
		display: "flex",
		position: "absolute",
		right: 0,
		"& ul": {
			padding: 5,
			display: "flex",
			"& li": {
				listStyle: "none",
				display: "flex",
				marginLeft: 50,
				transition: ".3s",
				"&:hover": {
					color: "#737373",
				},
			},
		},
	},
	menu: {
		width: "90%",
		position: "relative",
		maxWidth: 1700,
		margin: "auto",
		height: 60,
		[theme.breakpoints.down("sm")]: {
			display: "none",
		},
	},
	grow: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
	search: {
		position: "relative",
		borderRadius: theme.shape.borderRadius,
		backgroundColor: fade(theme.palette.common.white, 0.15),
		"&:hover": {
			backgroundColor: fade(theme.palette.common.white, 0.25),
		},
		marginRight: theme.spacing(2),
		marginLeft: 0,
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			marginLeft: theme.spacing(3),
			width: "auto",
		},
	},
	searchIcon: {
		width: theme.spacing(7),
		height: "100%",
		position: "absolute",
		pointerEvents: "none",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	inputRoot: {
		color: "inherit",
	},
	inputInput: {
		padding: theme.spacing(1, 1, 1, 7),
		transition: theme.transitions.create("width"),
		width: "100%",
		[theme.breakpoints.up("md")]: {
			width: 200,
		},
	},
	sectionDesktop: {
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex",
		},
	},
	sectionMobile: {
		display: "flex",
		justifyContent: " flex-end",
		height: 20,
		position: "relative",
		top: -10,
		[theme.breakpoints.up("md")]: {
			display: "none",
		},
		[theme.breakpoints.up("sm")]: {
			paddingRight: 20,
		},
	},
	txtAlign: {
		textAlign: "center"
	},
	imgWidth: {
		marginBottom: 50,
		"& img": {
			maxWidth: "initial"
		}
	}
}));
export default styles;
